import axios from 'axios';
import store from './../store/index';
import Swal from 'sweetalert2';

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        Authorization: 'Bearer ' + store.getters.token,
    },
});

http.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            Swal.fire('Tu sesión ha expirado', 'Por favor vuelve a iniciar sesión', 'warning');
            store.dispatch('logout');
        }

        if (error.response.status === 429) {
            Swal.fire('Demasiadas peticiones', 'Debes esperar 1 minuto para poder continuar', 'warning');
        }

        if (error.response.status === 503) {
            Swal.fire('App en mantenimiento', 'Por favor vuelve en un rato', 'warning');
            store.dispatch('logout');
        }
    });

export {http};
